module.exports = __webpack_public_path__ + "static/img/2020.4c61ec7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2020.png
// module id = Wyrx
// module chunks = 1